<div class="mb-3 flex align-items-center gap-2">
  <button
    pButton
    type="button"
    (click)="navigateToRegister()"
    class="p-button-success"
    pTooltip="ASIN手動登録"
    tooltipPosition="bottom">
    <i
      class="pi pi-plus"
      aria-hidden="true"></i>
    新規登録
  </button>
  <button
    pButton
    type="button"
    (click)="navigateToMain()"
    class="p-button-info"
    pTooltip="通知商品一覧"
    tooltipPosition="bottom">
    <i
      class="pi pi-arrow-left"
      aria-hidden="true"></i>
    通知商品一覧に戻る
  </button>
  <button
    pButton
    type="button"
    (click)="deleteSelected()"
    class="p-button-danger"
    [disabled]="selectedNotifications.length === 0"
    pTooltip="選択した項目を一括削除"
    tooltipPosition="bottom">
    <i
      class="pi pi-trash"
      aria-hidden="true"></i>
    選択削除 ({{ selectedNotifications.length }}件)
  </button>
</div>

<p-panel
  header="検索条件"
  [toggleable]="true"
  [collapsed]="false">
  <div class="grid">
    <div class="col-4">
      <label for="createdAtFrom">登録日時（以降）</label>
      <div class="card justify-content-center p-label">
        <p-datepicker
          [(ngModel)]="createdAtFrom"
          (onSelect)="onDateChange()"
          dateFormat="yy/mm/dd"
          placeholder="登録日時を選択"
          [showIcon]="true"
          inputId="createdAtFrom"></p-datepicker>
      </div>
    </div>
  </div>
</p-panel>

<div class="table-header-sticky-outer">
  全{{ notifications.length.toLocaleString() }}件
  <p-table
    #mainTable
    [value]="notifications"
    [(selection)]="selectedNotifications"
    [loading]="loading"
    columnResizeMode="expand"
    tableStyleClass="p-datatable-responsive"
    class="table-header-sticky p-datatable-responsive"
    [paginator]="true"
    [rows]="50"
    [rowsPerPageOptions]="[25, 50, 100]"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="{totalRecords} 件中 {first} 〜 {last}"
    paginatorPosition="both"
    dataKey="id"
    [globalFilterFields]="['amazonProduct.asin', 'amazonProduct.name', 'user.name', 'memo']">
    <ng-template #caption>
      <div class="table-caption">
        <div class="grid">
          <div class="col-8"></div>
          <div class="col-3">
            <span class="p-input-icon-left ml-auto input-full">
              <i class="pi pi-search"></i>
              <input
                pInputText
                class="input-full"
                type="text"
                (input)="mainTable.filterGlobal($event.target.value, 'contains')"
                placeholder="検索キーワード" />
            </span>
          </div>
          <div class="col-1">
            <button
              pButton
              class="p-button-outlined"
              (click)="mainTable.clear()">
              <i
                class="pi pi-filter-slash"
                aria-hidden="true"></i>
              Clear
            </button>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #header>
      <tr>
        <th width="4%">
          <p-tableheadercheckbox></p-tableheadercheckbox>
        </th>
        <th width="7%">画像</th>
        <th width="11%">Keepaグラフ</th>
        <th
          width="9%"
          pSortableColumn="amazonProduct.asin">
          ASIN
          <p-sorticon field="amazonProduct.asin"></p-sorticon>
        </th>
        <th width="24%">商品名</th>
        <th
          width="9%"
          pSortableColumn="user.name">
          登録者
          <p-sorticon field="user.name"></p-sorticon>
        </th>
        <th
          width="11%"
          pSortableColumn="createdAt">
          登録日時
          <p-sorticon field="createdAt"></p-sorticon>
        </th>
        <th width="19%">メモ</th>
        <th width="6%">操作</th>
      </tr>
    </ng-template>

    <ng-template
      #body
      let-notification>
      <tr>
        <td>
          <p-tablecheckbox [value]="notification"></p-tablecheckbox>
        </td>
        <td>
          <a
            href="https://keepa.com/#!product/5-{{ notification.amazonProduct.asin }}"
            target="_blank">
            <img
              src="{{ notification.amazonProduct.imageUrl }}"
              style="width: 60px; height: auto"
              alt="商品画像" />
          </a>
        </td>
        <td>
          <app-keepa-graph [asin]="notification.amazonProduct.asin"></app-keepa-graph>
        </td>
        <td>
          <a
            href="https://www.amazon.co.jp/dp/{{ notification.amazonProduct.asin }}"
            target="_blank">
            {{ notification.amazonProduct.asin }}
          </a>
          @if (notification.amazonProduct.keepaProduct?.boughtPastMonth != null) {
            <br />
            前月販売:
            {{
              notification.amazonProduct.keepaProduct.boughtPastMonth < 10
                ? '9以下'
                : notification.amazonProduct.keepaProduct.boughtPastMonth
            }}
          }
        </td>
        <td>
          <div
            class="text-overflow-ellipsis"
            [title]="notification.amazonProduct.name">
            {{ notification.amazonProduct.name }}
          </div>
        </td>
        <td>{{ notification.user.name }}</td>
        <td>{{ formatDate(notification.createdAt) }}</td>
        <td>
          <div class="flex align-items-center gap-2">
            <div
              class="text-overflow-ellipsis flex-1"
              [title]="notification.memo">
              {{ notification.memo || '-' }}
            </div>
            <i
              class="pi pi-user-edit clickable"
              style="font-size: 1rem; cursor: pointer; color: #007ad9"
              (click)="openMemoDialog(notification)"
              pTooltip="メモを編集"
              tooltipPosition="top"></i>
          </div>
        </td>
        <td>
          <i
            class="pi pi-trash clickable"
            style="font-size: 1rem; cursor: pointer; color: #dc3545"
            (click)="deleteNotification(notification)"
            pTooltip="削除"
            tooltipPosition="top"></i>
        </td>
      </tr>
    </ng-template>

    <ng-template #emptymessage>
      <tr>
        <td
          colspan="9"
          class="text-center">
          データがありません
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- メモ編集モーダル -->
<p-dialog
  header="メモを編集"
  [(visible)]="showMemoDialog"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [draggable]="false"
  [resizable]="false">
  @if (currentNotification) {
    <div class="grid">
      <div class="col-12 mb-3">
        <div class="flex align-items-center gap-2">
          <img
            [src]="currentNotification.amazonProduct.imageUrl"
            style="width: 40px; height: auto"
            alt="商品画像" />
          <div>
            <div class="font-semibold">{{ currentNotification.amazonProduct.name }}</div>
            <div class="text-sm text-gray-600">ASIN: {{ currentNotification.amazonProduct.asin }}</div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <label for="memoTextarea">メモ</label>
        <textarea
          id="memoTextarea"
          rows="4"
          class="p-inputtext w-full"
          pTextarea
          [(ngModel)]="memoText"
          placeholder="メモを入力してください"></textarea>
      </div>
      <div class="col-12 flex justify-content-end gap-2 mt-3">
        <button
          pButton
          type="button"
          class="p-button-outlined"
          (click)="closeMemoDialog()">
          キャンセル
        </button>
        <button
          pButton
          type="button"
          (click)="saveMemo()">
          保存
        </button>
      </div>
    </div>
  }
</p-dialog>
